import { render, staticRenderFns } from "./SmartShop.vue?vue&type=template&id=fc83cef2&scoped=true"
import script from "./SmartShop.vue?vue&type=script&lang=js"
export * from "./SmartShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc83cef2",
  null
  
)

export default component.exports